var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 6C11.25 3.10051 8.89952 0.75 6 0.75C3.10051 0.75 0.75 3.10051 0.75 6C0.75 8.89952 3.10051 11.25 6 11.25C8.89952 11.25 11.25 8.89952 11.25 6ZM7.99406 4.38909L7.62282 4.01786C7.50567 3.9007 7.31572 3.9007 7.19856 4.01786L6.00471 5.21099L4.81207 4.01829C4.69492 3.90114 4.50497 3.90114 4.38781 4.01829L4.01658 4.38953C3.89942 4.50668 3.89942 4.69663 4.01658 4.81379L5.20896 6.00674L4.01658 7.19984C3.89942 7.317 3.89942 7.50695 4.01658 7.6241L4.38781 7.99534C4.50497 8.11249 4.69492 8.11249 4.81207 7.99534L6.00471 6.80174L7.19856 7.99577C7.31572 8.11293 7.50567 8.11293 7.62282 7.99577L7.99406 7.62454C8.11121 7.50738 8.11121 7.31743 7.99406 7.20027L6.80046 6.00674L7.99406 4.81336C8.11121 4.6962 8.11121 4.50625 7.99406 4.38909Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.7e013752ed49faa3834005706f178114.svg";
export { ForwardRef as ReactComponent };